module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "headline bold"
  }, [_vm._v("Add items to forecasts")]), _vm._v(" "), _c('div', {
    staticClass: "headline-2"
  }, [_vm._v("Eligible forecasts:")]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "small-text"
  }, [_vm._v("status / forecast ref + name / current qty of items")]), _vm._v(" "), _c('table', [_c('tbody', _vm._l((_vm.forecasts), function(forecast) {
    return _c('tr', {
      key: forecast.id
    }, [_c('td', [_c('ForecastStatus', {
      attrs: {
        "status": forecast.deleted ? 'DELETE' : forecast.status,
        "short": true
      }
    }), _c('span', {
      staticClass: "name-ref"
    }, [_vm._v(_vm._s(forecast.reference) + " - " + _vm._s(forecast.name) + " (" + _vm._s(forecast.numberOfItems) + ")")])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedForecasts),
        expression: "selectedForecasts"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": forecast,
        "checked": Array.isArray(_vm.selectedForecasts) ? _vm._i(_vm.selectedForecasts, forecast) > -1 : (_vm.selectedForecasts)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedForecasts,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = forecast,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedForecasts = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedForecasts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedForecasts = $$c
          }
        }
      }
    })])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_c('div', [_c('ClientColorButton', {
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("Add to forecasts")])], 1)])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c8d77c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/MultiSelectModal.vue
// module id = 3250
// module chunks = 0